"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAllPages = void 0;
// Fetch all pages of data, given a functino to fetch a single page.
//
// The `fetchSinglePage` function is passed a single argument, the page of data to fetch, and
// expected to resolve a core-api-like data response, which includes these keys:
// - `next`, which indicates if there is another page of data for the system to fetch.
// - `results`, which contains an array of data items that are contained within that data page.
// - `total`, which contains the total number of items in the response.
//
// Example call: fetchSinglePage(1)
// Example response: {next: 'https://api.density.io/v2/spaces?page=2', total: 18, results: [1, 2, 3, 4, 5]}
function fetchAllPages(fetchSinglePage, test) {
    if (test === void 0) { test = function (_) { return true; }; }
    var getPage = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var data, _a, all, rest, key;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetchSinglePage(page)];
                    case 1:
                        data = _b.sent();
                        // If endpoint just returns an array, don't try to paginate
                        if (data && typeof data.length !== 'undefined') {
                            return [2 /*return*/, data];
                        }
                        // Check that the page exists and contains the necessary properties
                        if (!data) {
                            throw new Error("Function did not return a page of data! (data=".concat(data, ")"));
                        }
                        if (typeof data.next === 'undefined') {
                            throw new Error("Page of data did not contain .next key! (data=".concat(JSON.stringify(data), ")"));
                        }
                        if (typeof data.results === 'undefined') {
                            throw new Error("Page of data did not contain .results key! (data=".concat(data, ")"));
                        }
                        if (!(data.next && test(data))) return [3 /*break*/, 6];
                        if (!Array.isArray(data.results)) return [3 /*break*/, 3];
                        _a = [__spreadArray([], data.results, true)];
                        return [4 /*yield*/, getPage(page + 1)];
                    case 2: 
                    // When an array, add items to the array.
                    return [2 /*return*/, __spreadArray.apply(void 0, _a.concat([(_b.sent()), true]))];
                    case 3:
                        all = {};
                        return [4 /*yield*/, getPage(page + 1)];
                    case 4:
                        rest = _b.sent();
                        for (key in data.results) {
                            all[key] = __spreadArray(__spreadArray([], data.results[key], true), rest[key], true);
                        }
                        return [2 /*return*/, all];
                    case 5: return [3 /*break*/, 7];
                    case 6: return [2 /*return*/, data.results];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return getPage(1);
}
exports.fetchAllPages = fetchAllPages;
//# sourceMappingURL=index.js.map